// extracted by mini-css-extract-plugin
module.exports = {"morebtn":"Tw874","fullWidth":"G9PFV","redBrdr":"BeCH0","redbg":"yfckQ","disabled":"QY7YR"};